<template>
  <data-cell-text
    v-bind="$attrs"
    :value="value"
    :item="item"
    :context="context"
    @edit="onEdit"
  />
</template>

<script setup lang="ts">
import DataCellText from "@/components/controls/grid/renderers/DataCellText.vue";
import type { Renderable } from "@/components/controls/grid/BmGridData";
import type { TextTruncationOptions } from "@/components/controls/grid/builder/ColumnBuilders";
import { showModalDialog } from "@/components/platform/common/showModalDialog";
import DataCellInfoDialog from "@/components/controls/grid/renderers/info/DataCellInfoDialog.vue";

interface DataCellTextInfoProps {
  value?: unknown;
  item?: unknown;
  context?: Renderable;
}

const props = defineProps<DataCellTextInfoProps>();

async function onEdit() {
  const textTruncationOptions: TextTruncationOptions<unknown> | undefined =
    props.context?.rendererMetadata.textTruncationOptions;

  if (textTruncationOptions && props.item) {
    const { extractor, title, width } = textTruncationOptions;
    const infoToDisplay = extractor(props.item);

    // Open using showModalDialog so it doesn't close if the grid updates
    await showModalDialog<void, typeof DataCellInfoDialog>(DataCellInfoDialog, {
      props: {
        infoToDisplay,
      },
      attrs: {
        label: title,
        width,
      },
    });
  }
}
</script>
